import React from 'react';
import { HOME_PAGE } from '../../../../../../config/app-config';
import { Button } from '../../../../../../components/ui/button';
import { ArrowRight } from 'lucide-react';

export default function GlobalErrorsPage() {
  function onRedirectClick() {
    window.location.href = HOME_PAGE.route;
  }

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center bg-gray-100">
      <div className="max-w-3xl px-4 text-center lg:px-0">
        <h1 className="mb-6 text-4xl font-bold text-gray-800 sm:text-5xl">{'Un problème est survenu'}</h1>
        <p className="text-gray-600">{'Nous n’avons pas réussi à afficher correctement cette page.'}</p>
        <p className="mb-8 text-gray-600">{'Contactez nous si le problème persiste.'}</p>
        <Button variant={'primary'} dataId={'redirect-to-homepage'} onClick={onRedirectClick}>
          {"Retourner à l'accueil"}
          <ArrowRight className={'ml-2 size-4'} />
        </Button>
      </div>
    </div>
  );
}
